import axios from "axios";
import {getBackendURL, httpResponse, httpResponseError} from "../../fn";

/**
 * Получить список событий Росреестра
 * @param dealId
 * @returns {Promise<unknown>}
 */
export const getDealEvents = async (dealId) =>  {
  const result = await new Promise((resolve) => {
    axios.get(`${getBackendURL()}/deal/${dealId}/events`, {
      withCredentials: true,
      headers: {
        'content-type': 'multipart/form-data',
      },
    }).then((response) => {
      resolve(httpResponse(response.data))
    }).catch((error) => {
      resolve(httpResponseError(error));
    });
  })

  return result;
}

/**
 * Получить количество сделок ожидающих оплату
 * @param dealId
 * @returns {Promise<unknown>}
 */
export const getDealsNumWaitingPayment = async () =>  {
  const result = await new Promise((resolve) => {
    axios.get(`${getBackendURL()}/deal/awaitpayment/num/`, {
      withCredentials: true,
      headers: {
        'content-type': 'multipart/form-data',
      },
    }).then((response) => {
      resolve(httpResponse(response.data))
    }).catch((error) => {
      resolve(httpResponseError(error));
    });
  })

  return result;
}

/**
 * Запинить сделку в списке
 * @param dealId
 */
export const pinDealAPI = async (dealId) => {
  const result = await new Promise((resolve) => {
    axios.post(`${getBackendURL()}/deal/${dealId}/pin`, {
      withCredentials: true,
      headers: {
        'content-type': 'multipart/form-data',
      },
    }).then(() => {
      resolve(httpResponse())
    }).catch((error) => {
      resolve(httpResponseError(error));
    });
  })

  return result;
}

/**
 * открепить сделку в списке
 * @param dealId
 */
export const unpinDealAPI = async (dealId) => {
  const result = await new Promise((resolve) => {
    axios.post(`${getBackendURL()}/deal/${dealId}/unpin`, {
      withCredentials: true,
      headers: {
        'content-type': 'multipart/form-data',
      },
    }).then(() => {
      resolve(httpResponse())
    }).catch((error) => {
      resolve(httpResponseError(error));
    });
  })

  return result;
}

/**
 *
 * @param offset
 * @returns {Promise<HttpResponseOk|HttpResponseError>}
 */
export const getListData = async (offset)  => {
  const result = await new Promise((resolve) => {
    axios.get(`${getBackendURL()}/deal/list/${offset}/50`, {
      withCredentials: true,
      headers: {
        'Accept': '*/*',
        'content-type': 'application/json'
      },
    }).then((response) => {
      resolve(httpResponse(response.data))
    }).catch((error) => {
      resolve(httpResponseError(error))
    });
  })

  return result;
}

export const findDealRequest = async (val) => {
  const result = await new Promise((resolve) => {
    axios.post(`${getBackendURL()}/deal/list/filter/`, {filter: val}, {
      withCredentials: true,
      headers: {
        'content-type': 'application/json',
      },
    }).then((response) => {
      resolve(httpResponse(response.data))
    }).catch((error) => {
      resolve(httpResponseError(error));
    });
  })

  return result;
}

export const getListDataWStateFilter = async (state, offset) => {
  const result = await new Promise((resolve) => {
    axios.post(`${getBackendURL()}/deal/list/state/${state}/offset/${offset}`, {
      withCredentials: true,
      headers: {
        'Accept': '*/*',
        'content-type': 'application/json'
      },
    }).then((response) => {
      resolve(httpResponse(response.data))
    }).catch((error) => {
      resolve(httpResponseError(error))
    });
  })

  return result;
}

export const copyDeal = async (dealId) => {
  const result = await new Promise((resolve) => {
    axios.post(`${getBackendURL()}/deal/${dealId}/copy`, {
      withCredentials: true,
      headers: {
        'Accept': '*/*',
        'content-type': 'application/json'
      },
    }).then((response) => {
      resolve(httpResponse(response.data))
    }).catch((error) => {
      resolve(httpResponseError(error))
    });
  })

  return result
}

export const deleteDeal = async (dealId) => {
  const result = await new Promise((resolve) => {
    axios.delete(`${getBackendURL()}/deal/${dealId}`, {
      withCredentials: true,
      headers: {
        'Accept': '*/*',
        'content-type': 'application/json'
      },
    }).then((response) => {
      resolve(httpResponse(response.data))
    }).catch((error) => {
      resolve(httpResponseError(error))
    });
  })

  return result
}